import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const ItemCheckbox = styled.div`
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  margin-top: 5px;
  margin-right: 8px;
  border-radius: 50%;
  border: 1px solid ${COLORS.gray60};
`;

export default ItemCheckbox;
